import React from 'react';
import { Badge } from '@mui/material';
import NodeContent from './NodeContent';
import classNames from 'classnames';
import NodeExpandButton from './NodeExpandButton';
export var NodeHoverState;
(function (NodeHoverState) {
    NodeHoverState["HIGHLIGHTED"] = "HIGHLIGHTED";
    NodeHoverState["DIMMED"] = "DIMMED";
    NodeHoverState["NONE"] = "NONE";
})(NodeHoverState || (NodeHoverState = {}));
var Node = function (_a) {
    var id = _a.id, icon = _a.icon, label = _a.label, isMini = _a.isMini, expandable = _a.expandable, expanded = _a.expanded, hoverState = _a.hoverState, unlinked = _a.unlinked, hasCyclicLink = _a.hasCyclicLink, onClick = _a.onClick, onExpandToggle = _a.onExpandToggle, onHoverStart = _a.onHoverStart, onHoverStop = _a.onHoverStop, children = _a.children;
    var handleClick = function (e) {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    };
    return (React.createElement("div", { className: classNames('node', { 'node--mini': isMini }, { 'node--highlighted': hoverState === NodeHoverState.HIGHLIGHTED }, { 'node--dimmed': hoverState === NodeHoverState.DIMMED }, { 'node--unlinked': unlinked }), id: id, onMouseEnter: onHoverStart, onMouseLeave: onHoverStop, onClick: handleClick },
        hasCyclicLink ? React.createElement(Badge, { className: 'node__badge', variant: 'dot', color: 'primary' }) : null,
        React.createElement(NodeContent, { label: label, icon: icon }),
        expandable &&
            React.createElement(NodeExpandButton, { expanded: expanded, setExpanded: onExpandToggle }),
        children ?
            React.createElement("div", { className: 'node__children' }, children)
            : null));
};
export default Node;
//# sourceMappingURL=Node.js.map